import { render, staticRenderFns } from "./MembershipLink.vue?vue&type=template&id=2c2bfd15&"
import script from "./MembershipLink.vue?vue&type=script&lang=ts&"
export * from "./MembershipLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports